exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invoice-filter-container .filter.failed .count[data-v-1b620872] {\n  background: #b30505;\n}", ""]);

// exports
